import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs, ref, onMounted, watch } from "vue";
import { cloneDeep }                     from "lodash";

import { AppFieldHtml } from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  props: {
        field:      {
            type:     Object,
            required: true
        },
        error:      [ String, Boolean ],
        inputClass: String,
        modelValue: {}
    },
  emits: [ 'update:modelValue' ],
  setup(__props, { emit }) {

const props = __props

const persistentStore = window.Store;


const { field, error, inputClass, modelValue } = toRefs( props );



const theme = ref( 'default' );
const value = ref( '' );

onMounted( async (): Promise<void> => {
    if ( !field.value.options.theme ) {
        await setTheme();
    }

    value.value = !( field.value.value === undefined || field.value.value === null )
                  ? field.value.value
                  : '';

    watch( () => modelValue.value, v => {
        value.value = cloneDeep( v ) || '';
    }, { deep: true } );

    watch( () => value.value, v => emit( 'update:modelValue', v ), { deep: true } );
} );

/**
 * Change editor to dark mode if user is in dark mode
 */
const setTheme = async (): Promise<void> => {
    if ( window.Stack ) {

        // const defaultMode = window.desktop.darkMode() ? "dark" : "light";

        const defaultMode = ( await window.Stack.send( "dark-mode.get" ) )
                            ? "dark"
                            : "light";
        let userMode      = persistentStore.get( "ui-theme" );
        let mode          = !userMode ? defaultMode : userMode;

        const darkMode =
                  ( userMode && userMode === "dark" ) ||
                  ( !userMode && mode === "dark" ) ||
                  false;

        if ( darkMode ) {
            theme.value = "material-palenight";
        }
    } else {
        if ( window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
            theme.value = "material-palenight";
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AppFieldHtml), {
    theme: theme.value,
    field: _unref(field),
    error: _unref(error),
    "input-class": _unref(inputClass),
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
  }, null, 8, ["theme", "field", "error", "input-class", "modelValue"]))
}
}

})